export enum QrCodePrintTypes {
    Single = 'single',
    All = 'all',
    Admin = 'admin'
}
